import { AddressDocument } from '@util/types/firestore/address';
import { functions, httpsCallable } from '@util/firebase';
import { GetTaxArgs, GetTaxResponse } from './types';

// total arg is the subtotal
export async function getTax(args: GetTaxArgs): Promise<GetTaxResponse> {
  const response = await httpsCallable<GetTaxArgs, GetTaxResponse>(
    functions,
    'getTax'
  )(args);
  return response.data;
}

// Batch calculate tax for all items via Next.js API route.
// Single request: batch-reads sellers from Firestore, calls TaxJar per item in parallel.
export async function calculateTaxBatch(
  items: { product_id: string; seller_id: string; total: number; shipping: number }[],
  to_address: AddressDocument
): Promise<GetTaxResponse[]> {
  const res = await fetch('/api/checkout/calculate-tax', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items, to_address }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error ?? 'Failed to calculate tax');
  }

  const data = await res.json();
  return data.results;
}
